import { useTranslation } from 'react-i18next'

import { Flex, OrganisationHeaderWithImage } from '@percent/lemonade'
import styles from './OrganisationPreview.module.scss'
import { OrganisationPreviewProps } from './OrganisationPreview.types'

export function OrganisationPreview({ organisation }: Readonly<OrganisationPreviewProps>) {
  const { t } = useTranslation()
  const { name, countryCode, registryId, website, logo, address, postcode } = organisation
  const addressLine = [address, postcode].filter(Boolean).join(', ')

  return (
    <Flex
      key={name}
      direction="column"
      align="flex-start"
      gap={16}
      w="100%"
      className={styles.organisationPreview}
      data-testid="organisation-preview"
    >
      <OrganisationHeaderWithImage
        title={name}
        countryCode={countryCode}
        iconUrl={logo}
        website={website}
        registryId={t('grants.candidates.addOrganisationModal.registryId', { registryId })}
      />
      {addressLine ? (
        <span className={styles.organisationPreviewAddress} data-testid="organisation-preview-address">
          {addressLine}
        </span>
      ) : null}
    </Flex>
  )
}
